import {Observable, Observer} from 'rxjs/Rx';

export class ErrorNotifierService {
  private errorObservable:Observable<any>;
  private errorObserver:Observer<any>;
  private okObservable:Observable<any>;
  private okObserver:Observer<any>;

  constructor() {
    this.errorObservable = Observable.create((observer:Observer<any>) => {
      this.errorObserver = observer;
    }).share();

    this.okObservable = Observable.create((observer:Observer<any>) => {
      this.okObserver = observer;
    }).share();
  }

  notifyError(error:any) {
    this.errorObserver.next(error);
  }

  onError(callback:(err:any) => void) {
    this.errorObservable.subscribe(callback);
  }

  notifyOk() {
    this.okObserver.next(true);
  }

  onOk(callback:(err:any) => void) {
    this.okObservable.subscribe(callback);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/error-notifier/error.notifier.ts